import { MDBBtn } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import SMSEnabledRequest from "../popups/phonenumbers/SMSEnabledRequest";
import {
  getMisc,
  updateSMSCampaigns,
} from "../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import CampaignAssignTeleNumbers from "../popups/globalaccount/brandAndSMS/CampaignAssignTeleNumbers";
import UIConstant from "../../apiclients/UIConstant";

function CampaignAssignNumbers({
  // register,
  // watch,
  // setValue,
  // errors,
  setSuccessMessage,
  // setError,
  assignedPhoneNumbers,
  campaignid,
  brandid,
  setRerender,
  sourceNumber,
  status,
  setInternalError,
  setIsloading,
  isCampaignEdit,
}) {
  const [SMSEnableRequest, setSMSEnableRequest] = useState(false);
  const [assigndNumbers, setassigndNumbers] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [updatebulkNumbersExecuted, setUpdatebulkNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const [bulkError, setBulkError] = useState(null);
  const [bulkSuccess, setBulkSuccess] = useState(false);
  const navigate = useNavigate();
  const SMSEnableRequesttoggleOpen = () =>
    setSMSEnableRequest(!SMSEnableRequest);

  useEffect(() => {
    if (assignedPhoneNumbers && assignedPhoneNumbers.length > 0) {
      setassigndNumbers(assignedPhoneNumbers);
      setdbPhoneNumbers(assignedPhoneNumbers);
    }
  }, [assignedPhoneNumbers]);

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("add_phnums");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("remove_phnums");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

    useEffect(() => {
    if (updatePHNum.length > 0 && updatebulkNumbersExecuted) {
      setBulkError(null);
      addPhoneNumbers("bulk_phnums");
      // setUpdateNumbersExecuted(false);
      setUpdatebulkNumbersExecuted(false);
    }
  }, [updatePHNum , updatebulkNumbersExecuted]);

  async function addPhoneNumbers(fieldName) {
    let update = {
      reqid: 174,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      brand_id: brandid,
      campaign_id: campaignid,
      ph_numbers: {
        [fieldName]: updatePHNum,
      },
    };

    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    setIsloading(true);
    let saverep = await updateSMSCampaigns(update);
    setIsloading(false);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "add_phnums" || fieldName === "bulk_phnums") {
        let updatedNumbers = [];
        if (status === "Pending" && isCampaignEdit) {
          updatedNumbers = updatePHNum.map((num) => ({
            nums: num,
            status: 5,
            reason: null,
          }));
        } else {
          updatedNumbers = updatePHNum.map((num) => ({
            nums: num,
            status: 1,
            reason: null,
          }));
        }

        setassigndNumbers((prev) => [...prev, ...updatedNumbers]);
        setdbPhoneNumbers((prev) => [...prev, ...updatedNumbers]);
        if (fieldName === "bulk_phnums") {
          setBulkError(null);
          setBulkSuccess(true);
        }
        setSuccessMessage(saverepeMsg.message);
      } else {
        const updateAddPHNum = assigndNumbers.filter(
          (num) => !updatePHNum.includes(num.nums),
        );
        if (status === "Pending" && isCampaignEdit) {
          setassigndNumbers([...updateAddPHNum]);
          setdbPhoneNumbers([...updateAddPHNum]);
        } else {
          const updatedNumbers = updatePHNum.map((num) => ({
            nums: num,
            status: 2,
            reason: null,
          }));
          setassigndNumbers([...updateAddPHNum, ...updatedNumbers]);
          setdbPhoneNumbers([...updateAddPHNum, ...updatedNumbers]);
         
        }
         setSuccessMessage(saverepeMsg.message);
      }
    } else {
      if (
        fieldName === "bulk_phnums" &&
        saverepeMsg.message &&
        saverepeMsg.message.errors
      ) {
        setBulkSuccess(false);
        setBulkError(saverepeMsg?.message?.errors[0]?.message);
      } else if (fieldName === "remove_phnums") {
        const modifynum = assigndNumbers.filter(
          (num) => !updatePHNum.includes(num.nums),
        );
        const updatedNumbers = updatePHNum.map((num) => ({
          nums: num,
          status: 0,
          reason: null,
        }));
        setassigndNumbers([...modifynum, ...updatedNumbers]);
        setdbPhoneNumbers([...modifynum, ...updatedNumbers]);
      } else if (
        saverepeMsg.message &&
        typeof saverepeMsg.message !== "object"
      ) {
        setInternalError(saverepeMsg.message);
      } else {
        setInternalError(
          "An error occurred while updating phone numbers. Please try again.",
        );
      }
    }
  }
  return (
    <>
      <div>
        <p className="general-settings">
          Select Phone Numbers
        </p>
        <div
          {...((status === "Pending" && !isCampaignEdit) || UIConstant.CampaignStatus.includes(status) 
            ? {
              title:
                `This campaign is in a ${status} state, so phone numbers cannot be edited.`,
              className: "disabled-form cursor-notAllowed",
              onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
              },
            }
            : {})}
        >
          <CampaignAssignTeleNumbers
            savedPhoneNumbers={assigndNumbers}
            setSavedPhoneNumbers={setassigndNumbers}
            setSuccessMessage={setSuccessMessage}
            uniqueid={null}
            setUpdatePHNum={setUpdatePHNum}
            setUpdateNumbersExecuted={setUpdateNumbersExecuted}
            setUpdatebulkNumbersExecuted={setUpdatebulkNumbersExecuted}
            sourceNumber={sourceNumber}
            setDeleteNumberFlag={setDeleteNumberFlag}
            campaignid={campaignid}
            brandid={brandid}
            setRerender={setRerender}
            dbPhoneNumbers={dbPhoneNumbers}
            status={status}
            bulkApiError={bulkError}
            bulkApiSuccess={bulkSuccess}
            setBulkApiSuccess={setBulkSuccess}
            isCampaignEdit={isCampaignEdit}
          />
        </div>
      </div>
      {SMSEnableRequest && (
        <SMSEnabledRequest
          onClose={SMSEnableRequesttoggleOpen}
          campaignFlag={true}
          setSuccessMessage={setSuccessMessage}
        />
      )}
    </>
  );
}

export default CampaignAssignNumbers;